import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { HR } from 'foundations-components/transitional/components/HR';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { BREACHED, IN_SLA, RESOLVED_IN_SLA, RESOLVED_OUT_OF_SLA, SLA_WARNING } from 'svh-tickets-lib/tickets/public/constants';
import SLADetailRow from './SLADetailRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SLATooltipHeader = ({
  activeSLAStatus
}) => {
  switch (activeSLAStatus) {
    case IN_SLA:
    case RESOLVED_IN_SLA:
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.statusHeaders.inSLA"
      });
    case BREACHED:
    case RESOLVED_OUT_OF_SLA:
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.statusHeaders.breached"
      });
    case SLA_WARNING:
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.statusHeaders.warning"
      });
    default:
      throw new Error('SLA status is not in SLAStatusEnum');
  }
};
SLATooltipHeader.displayName = 'SLATooltipHeader';
const SLADetailsTooltip = ({
  children,
  slas,
  activeSLA
}) => {
  const SLATooltipContent = () => /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(SLATooltipHeader, {
      activeSLAStatus: activeSLA.status
    }), /*#__PURE__*/_jsx(HR, {
      distance: "xs"
    }), Object.values(slas).map(sla => /*#__PURE__*/_jsx(SLADetailRow, {
      slaDetails: sla
    }, sla.category))]
  });
  SLATooltipContent.displayName = 'SLATooltipContent';
  return /*#__PURE__*/_jsx(Tooltip, {
    use: "longform",
    placement: "bottom",
    Content: SLATooltipContent,
    maxInlineSize: "600px",
    children: /*#__PURE__*/_jsx("span", {
      children: children
    })
  });
};
SLADetailsTooltip.displayName = 'SLADetailsTooltip';
export default SLADetailsTooltip;